export default {
  en: 'ltr',
  ar: 'rtl',
};
